import { useState } from 'react';
import { api } from '../lib/api.js';

export function TestUsersProvisionCard({ headers }) {
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [err, setErr] = useState('');
  async function provision() {
    setBusy(true); setErr(''); setResult(null);
    try {
      const r = await api('POST', '/api/admin/seed-test-users', {}, headers);
      setResult(r);
    } catch (e) { setErr(e.message || String(e)); }
    finally { setBusy(false); }
  }
  return (
    <div className="card">
      <div className="text-sm font-semibold">Provision test accounts</div>
      <div className="text-xs text-gray-500" style={{ marginBottom: 8 }}>
        Creates (or refreshes) the Test Manager + Test Staff accounts at Bristol used by the
        user-manual screenshot script. Idempotent — safe to run any time to reset passwords.
      </div>
      <button onClick={provision} disabled={busy} className="btn-primary"
        style={{ padding: '6px 14px' }}>
        {busy ? 'Provisioning…' : 'Provision test accounts'}
      </button>
      {err && <div style={{ marginTop: 8, fontSize: 12, color: '#b00020' }}>{err}</div>}
      {result && (
        <div style={{ marginTop: 10, padding: 10, background: '#fafafa', border: '1px solid #e0e0e0', borderRadius: 6 }}>
          <div style={{ fontSize: 12, color: '#2e7d32', fontWeight: 600, marginBottom: 6 }}>
            Done. Location: {result.location}.
          </div>
          <pre style={{ fontFamily: 'ui-monospace, Menlo, monospace', fontSize: 11, margin: 0, whiteSpace: 'pre-wrap' }}>
{(result.accounts || []).map(a => `${a.role.padEnd(8)} ${a.email}\n  password: ${a.password}\n  pin:      ${a.pin}`).join('\n\n')}
          </pre>
        </div>
      )}
    </div>
  );
}
